import {DashboardChartDataWmConfig} from './dashboard-chart-data-wm.symbols';
import {DashboardChartMetadataErrorIdentifier, DashboardChartMetadataStatus} from './dashboard-chart-data-general.symbols';

/**
 * Defines the WM score meanings for the chart.
 */
export enum DashboardChartDataWmScore {
  /** No data. */
  None = 'none',

  /** Good result. User's volume is better than average. */
  Low = 'low',

  /** Good result. User's volume is average. */
  Typical = 'typical',

  /** Bad result. User's volume is worse than average. */
  Elevated = 'elevated',

  /** Bad result. User's volume is much worse than average. */
  High = 'high',
}

/**
 * Defines the WM score group colors for the chart.
 */
export const DashboardChartDataWmGroupColors = {
  [DashboardChartDataWmScore.None]: '#2E4FD7',
  [DashboardChartDataWmScore.Low]: '#2E4FD7',
  [DashboardChartDataWmScore.Typical]: '#ABB9EF',
  [DashboardChartDataWmScore.Elevated]: '#FF99A3',
  [DashboardChartDataWmScore.High]: '#EC5564',
};

/**
 * Defines the WM score group by its value.
 */
export const dashboardChartDataDefineWmScoreGroup = (wmScore: number): DashboardChartDataWmScore => {
  if (wmScore === null || wmScore === undefined || wmScore === 0) {
    return DashboardChartDataWmScore.None;
  } else if (wmScore < 2) {
    return DashboardChartDataWmScore.Low;
  } else if (wmScore < 3) {
    return DashboardChartDataWmScore.Typical;
  } else if (wmScore < 4) {
    return DashboardChartDataWmScore.Elevated;
  } else {
    return DashboardChartDataWmScore.High;
  }
};

/**
 * Default empty values for the chart config.
 */
const wmChartDefaultConfigValues: DashboardChartDataWmConfig = {
  dataPointsConfig: [],
  chartMetadata: {
    processStatus: DashboardChartMetadataStatus.ShouldBeHidden,
    errorIdentifier: null,
  },
};

/**
 * Defines the last error identifier for the chart.
 * Returns compatible chart config.
 */
export const wmChartUtilsProvideErrorStatus = (errorIdentifier: DashboardChartMetadataErrorIdentifier): DashboardChartDataWmConfig => {
  return {
    ...wmChartDefaultConfigValues,
    chartMetadata: {
      processStatus: DashboardChartMetadataStatus.Error,
      errorIdentifier,
    },
  };
};

/**
 * Provides the chart config with the hidden status.
 */
export const wmChartUtilsProvideHiddenStatus = (): DashboardChartDataWmConfig => {
  return {
    ...wmChartDefaultConfigValues,
    chartMetadata: {
      processStatus: DashboardChartMetadataStatus.ShouldBeHidden,
      errorIdentifier: null,
    },
  };
};
